import i18n from "../i18n/i18n";

interface Profession {
    name: string;
    translations?: Record<string, string>;
}

export default function getTranslatedProfessionName(
    profession?: Profession
): string {
    const lang = i18n.language.split("-")[0];
    const translations = profession?.translations;

    if (translations && translations[lang]) {
        return translations[lang];
    }

    if (translations?.["en"]) {
        return translations["en"];
    }

    if (translations?.["ro"]) {
        return translations["ro"];
    }

    // fallback: use default French name
    return profession?.name ?? "";
}
